import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PlayerStatisticsStoreData } from './player-statistics.model';

export interface PlayerStatisticsState {
    [eventId: string]: {
        [marketFilter: string]: PlayerStatisticsStoreData;
    };
}

export const playerStatisticsInitialState: PlayerStatisticsState = {};

export const playerStatisticsStateKey = 'playerStatisticsState';

export const playerStatisticsSelector = createFeatureSelector<PlayerStatisticsState>(playerStatisticsStateKey);

export const selectDataByEventAndMarket = (eventId: string, marketFilter?: string, mainMarket?: boolean) =>
    createSelector(playerStatisticsSelector, (state: PlayerStatisticsState): PlayerStatisticsStoreData => {
        const key = mainMarket ? 'mainMarket' : marketFilter;
        if (!key) {
            return {
                isLoading: false,
                isError: false,
                data: undefined,
            };
        }
        return state[eventId]?.[key];
    });
